import indo from "@/config/indo";
import { XMLParser } from "fast-xml-parser";

const transformArray = (arrData, newParent) => {
  let newData = [...arrData];
  const temp = [...newData];
  newData = {};
  newData[newParent] = temp;

  return newData;
};

const parseDom = (data, domRoot) => {
  const xml = new DOMParser();
  const doc = xml.parseFromString(data, "text/xml");
  const element = doc.getElementsByTagName(domRoot)[0];
  if (!element) {
    throw new Error(`Elemento XML "${domRoot}" no encontrado en la respuesta`);
  }
  return element.innerHTML;
};

const decodeHtmlEntities = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};

export default {
  login(response) {
    return JSON.parse(parseDom(response.data, indo.login.methods.response));
  },

  renovarToken(response) {
    return JSON.parse(parseDom(response.data, indo.renovarToken.methods.response));
  },

  cerrarSesion(response) {
    return JSON.parse(parseDom(response.data, indo.cerrarSesion.methods.response));
  },

  loginManager(response) {
    return JSON.parse(parseDom(response.data, indo.loginManager.methods.response));
  },

  postLogin(response) {
    const xml = new DOMParser();
    const doc = xml.parseFromString(response.data, "text/xml");
    const data = doc.getElementsByTagName(indo.postLogin.methods.response)[0].innerHTML;
    const jsonData = JSON.parse(data);
    if (!jsonData.DatosConfig) {
      jsonData.DatosConfig = {};
    }

    jsonData.DatosConfig.ESPESORES = transformArray(
      jsonData.DatosConfig.ESPESORES ?? [],
      "clsZES_INET_ESPCLI",
    );
    jsonData.DatosConfig.listaFavoritos = transformArray(
      jsonData.DatosConfig.listaFavoritos ?? [],
      "clsFavoritos",
    );
    return jsonData;
  },

  pedidos(response) {
    return JSON.parse(parseDom(response.data, indo.pedidos.methods.response));
  },

  pedidoByNumero(response) {
    return JSON.parse(parseDom(response.data, indo.pedidoByNumero.methods.response));
  },

  nuevoPedido(response) {
    return parseDom(response.data, indo.nuevoPedido.methods.response);
  },

  GetContactosATCResult(response) {
    return JSON.parse(parseDom(response.data, indo.contactosATC.methods.response));
  },

  ajustes(response) {
    return JSON.parse(parseDom(response.data, indo.ajustes.methods.response));
  },

  recuperarDatosOptica(response) {
    const xml = new DOMParser();
    const doc = xml.parseFromString(response.data, "text/xml");
    const data = doc.getElementsByTagName(indo.recuperarDatosOptica.methods.response)[0].innerHTML;
    const jsonData = JSON.parse(data);


    // La respuesta ya viene con la estructura correcta:
    // { returnValue: 0, MensajeErrorSAP: '', oClaseBAPI: {...} }
    // Solo necesitamos envolver oClaseBAPI en DatosConfig para compatibilidad con el store
    const processedData = {
      returnValue: jsonData.returnValue || 0,
      MensajeErrorSAP: jsonData.MensajeErrorSAP || "",
      DatosConfig: jsonData.oClaseBAPI,
    };


    return processedData;
  },

  buzon(response) {
    return JSON.parse(parseDom(response.data, indo.miBuzon.methods.response));
  },

  cambioPassword(response) {
    return JSON.parse(parseDom(response.data, indo.cambioPassword.methods.response));
  },

  searchManagerFacturas(response) {
    return JSON.parse(parseDom(response.data, indo.buscarListaFacturas.methods.response));
  },

  searchPendientesFacturar(response) {
    return JSON.parse(parseDom(response.data, indo.buscarPendientesFacturar.methods.response));
  },

  bonos(response) {
    return JSON.parse(parseDom(response.data, indo.bonos.methods.response));
  },

  facturaPdf(response) {
    return JSON.parse(parseDom(response.data, indo.facturaSap.methods.response));
  },

  facturaSap(response) {
    return JSON.parse(parseDom(response.data, indo.facturaSap.methods.response));
  },

  bonoDetalle(response) {
    return JSON.parse(parseDom(response.data, indo.bonoDetalle.methods.response));
  },

  estadisticaServicio(response) {
    return JSON.parse(parseDom(response.data, indo.estadisticaServicio.methods.response));
  },

  estadisticaConsumo(response) {
    return JSON.parse(parseDom(response.data, indo.estadisticaConsumo.methods.response));
  },

  getBases(response) {
    return JSON.parse(parseDom(response.data, indo.basesEspeciales.methods.response));
  },

  enviarEmail(response) {
    return JSON.parse(parseDom(response.data, indo.enviarEmail.methods.response));
  },

  prepararPedido(response) {
    // calcular
    return JSON.parse(parseDom(response.data, indo.prepararPedido.methods.response));
  },

  reportarErrorPedido(response) {
    try {
      return JSON.parse(parseDom(response.data, indo.reportarErrorPedido.methods.response));
    } catch {
      return { ok: true, raw: response.data };
    }
  },

  realizarPedido(response) {
    return JSON.parse(parseDom(response.data, indo.realizarPedido.methods.response));
  },

  pedirContrasena(response) {
    return JSON.parse(parseDom(response.data, indo.pedirContrasena.methods.response));
  },

  cambiarContrasena(response) {
    return JSON.parse(parseDom(response.data, indo.cambiarContrasena.methods.response));
  },

  monturas(response) {
    return JSON.parse(parseDom(response.data, indo.monturas.methods.response));
  },

  formas(response) {
    return JSON.parse(parseDom(response.data, indo.guardarForma.methods.response));
  },

  buscarFormas(response) {
    return JSON.parse(parseDom(response.data, indo.buscarForma.methods.response));
  },

  formaFromImagenPicture(response) {
    return parseDom(response.data, indo.getFormaFromImagen.methods.result);
  },

  formaFromImagenOtrosDatos(response) {
    const xml = parseDom(response.data, indo.getFormaFromImagen.methods.otrosDatos);
    return decodeHtmlEntities(xml);
  },

  mimetikaLecturas(response) {
    return parseDom(response.data, indo.mimetikaLecturas.methods.response);
  },

  indocenterLecturas(response) {
    return parseDom(response.data, indo.indocenterLecturas.methods.response);
  },

  saveFavoritos(response) {
    return JSON.parse(parseDom(response.data, indo.saveFavoritos.methods.response));
  },

  segundasGafas(response) {
    return JSON.parse(parseDom(response.data, indo.segundasGafas.methods.response));
  },

  pedirExistencia(response) {
    return JSON.parse(parseDom(response.data, indo.pedirExistencia.methods.response));
  },

  recetas(response) {
    return JSON.parse(parseDom(response.data, indo.recetas.methods.response));
  },

  borrarPedido(response) {
    return JSON.parse(parseDom(response.data, indo.borrarPedido.methods.response));
  },

  recuperarPedido(response) {
    return JSON.parse(parseDom(response.data, indo.recuperarPedido.methods.response));
  },
  guardarDatosBIGEXACT(response) {
    return JSON.parse(parseDom(response.data, indo.guardarDatosBIGEXACT.methods.response));
  },
  cargarDatosBIGEXACT(response) {
    return JSON.parse(parseDom(response.data, indo.cargarDatosBIGEXACT.methods.response));
  },
  getTranslatedJergaDetails(response) {
    return JSON.parse(parseDom(response.data, indo.getTranslatedJergaDetails.methods.response));
  },
  recetas(response) {
    return JSON.parse(parseDom(response.data, indo.recetas.methods.response));
  },
  guardarReceta(response) {
    return JSON.parse(parseDom(response.data, indo.guardarReceta.methods.response));
  },
  recuperarReceta(response) {
    return JSON.parse(parseDom(response.data, indo.recuperarReceta.methods.response));
  },
  borrarRecetas(response) {
    return JSON.parse(parseDom(response.data, indo.borrarRecetas.methods.response));
  },
  enviarRecetas(response) {
    return JSON.parse(parseDom(response.data, indo.enviarRecetas.methods.response));
  },
  buscarMotivosDevolucionesInadapt(response) {
    return JSON.parse(
      parseDom(response.data, indo.buscarMotivosDevolucionesInadapt.methods.response),
    );
  },
  crearDevolucionInadapt(response) {
    return JSON.parse(parseDom(response.data, indo.crearDevolucionInadapt.methods.response));
  },
  buscarNumeroRecogidas(response) {
    return JSON.parse(parseDom(response.data, indo.buscarNumeroRecogidas.methods.response));
  },

  crearRecogida(response) {
    return JSON.parse(parseDom(response.data, indo.crearRecogida.methods.response));
  },
  buscarDevolucionesTramitadas(response) {
    return JSON.parse(parseDom(response.data, indo.buscarDevolucionesTramitadas.methods.response));
  },
  getComercialFoto(response) {
    // La respuesta viene como XML, necesitamos parsearla
    const xml = new DOMParser();
    const doc = xml.parseFromString(response.data, "text/xml");
    const resultElement = doc.getElementsByTagName(indo.getComercialFoto.methods.response)[0];

    if (!resultElement) {
      return {};
    }

    const innerHTML = resultElement.innerHTML;

    try {
      const jsonData = JSON.parse(innerHTML);
      return jsonData;
    } catch (error) {
      return {};
    }
  },

  datosBuscadorWeb(response) {
    return JSON.parse(parseDom(response.data, indo.datosBuscadorWeb.methods.response));
  },
  getDescripcionTratamiento(response) {
    return JSON.parse(parseDom(response.data, indo.getDescripcionTratamiento.methods.response));
  },
  getDescripcionBasePrisma(response) {
    return JSON.parse(parseDom(response.data, indo.getDescripcionBasePrisma.methods.response));
  },
  getTienePosicionUso(response) {
    return JSON.parse(parseDom(response.data, indo.getTienePosicionUso.methods.response));
  },
  getAlertasCliente(response) {
    // Devolver la respuesta directamente sin parsear
    return response;
  },

  requestInformacionFiscal(response) {
    const xml = new DOMParser();
    const doc = xml.parseFromString(response.data, "text/xml");
    const element = doc.getElementsByTagName(indo.requestInformacionFiscal.methods.response)[0];
    if (!element) throw new Error("Elemento XML no encontrado en la respuesta");
    return JSON.parse(element.textContent);
  },

  buscarListaClientes(response) {
    return JSON.parse(parseDom(response.data, indo.buscarListaClientes.methods.response));
  },

  changePassword(response) {
    // Parsear el XML para obtener CambioPasswordIMResult
    const xml = new DOMParser();
    const doc = xml.parseFromString(response.data, "text/xml");

    // Obtener el nodo CambioPasswordIMResult
    const resultNode = doc.getElementsByTagName("CambioPasswordIMResult")[0];

    if (!resultNode) {
      throw new Error("Respuesta inválida del servidor");
    }

    // Extraer Mensaje y sRetorno
    const mensajeNode = resultNode.getElementsByTagName("Mensaje")[0];
    const sRetornoNode = resultNode.getElementsByTagName("sRetorno")[0];

    const mensaje = mensajeNode ? mensajeNode.textContent : "";
    const sRetorno = sRetornoNode ? parseInt(sRetornoNode.textContent) : -1;

    return {
      Mensaje: mensaje,
      sRetorno: sRetorno,
    };
  },

  recuperarAlbaran(response) {
    const xml = new DOMParser();
    const doc = xml.parseFromString(response.data, "text/xml");

    // Buscar el elemento RecuperarAlbaranResult
    const albaranResultElement = doc.getElementsByTagName("RecuperarAlbaranResult")[0];

    if (!albaranResultElement) {
      return { error: "No se encontró respuesta del servidor" };
    }

    // Verificar retorno
    const sRetornoElement = albaranResultElement.getElementsByTagName("sRetorno")[0];
    if (!sRetornoElement || sRetornoElement.textContent !== "OK") {
      return { error: "El servidor no devolvió OK" };
    }

    // Extraer el contenido base64
    const contenidoElement = albaranResultElement.getElementsByTagName("contenido")[0];
    if (!contenidoElement || !contenidoElement.textContent) {
      return { error: "No se encontró el contenido del albarán" };
    }

    return {
      contenido: contenidoElement.textContent,
      returnValue: 0,
    };
  },

  abrirReclamacionFactura(response) {
    return JSON.parse(parseDom(response.data, indo.abrirReclamacionFactura.methods.response));
  },
};
